import React from 'react';

const Bathtub = ({ className }) => (
    <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={className}
    >
        <title>Page 1</title>
        <defs>
            <path id="a" d="M0 25.367h26V0H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="b" fill="#fff">
                <use xlinkHref="#a" />
            </mask>
            <path
                d="M24.5 13.868h-23c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h23c.276 0 .5.224.5.5s-.224.5-.5.5zm-.5 2.5c0 3.032-2.468 5.5-5.5 5.5h-11c-3.032 0-5.5-2.468-5.5-5.5v-1.5h22v1.5zM8.207 2.076c.22 0 .443.048.647.145l-2 2.002c-.266-.558-.168-1.247.292-1.708.293-.292.677-.438 1.06-.438zM26 13.368c0-.827-.673-1.5-1.5-1.5H4V1.503c0-.295.22-.42.288-.453.067-.032.305-.12.532.068L6.118 2.2c-.638.97-.53 2.29.32 3.143.1.097.227.146.355.146.128 0 .256-.05.353-.147l2.83-2.83c.194-.194.194-.51 0-.706-.856-.854-2.18-.96-3.15-.315-.002-.003-.003-.006-.006-.008L5.46.35C5.008-.026 4.396-.106 3.864.144 3.33.394 3 .914 3 1.504v10.364H1.5c-.827 0-1.5.673-1.5 1.5 0 .65.42 1.2 1 1.407v1.593c0 3.296 2.47 6.02 5.654 6.438L5.572 24.61c-.143.237-.066.544.17.686.08.05.17.072.258.072.17 0 .335-.087.428-.243l1.355-2.257h10.434l1.355 2.257c.093.156.26.243.428.243.088 0 .177-.023.258-.072.236-.142.313-.45.17-.686l-1.082-1.804C22.53 22.39 25 19.664 25 16.368v-1.593c.58-.207 1-.756 1-1.407z"
                fill="#4A4A4A"
                mask="url(#b)"
            />
        </g>
    </svg>
);

Bathtub.displayName = 'Bathtub';

/**
 * Bathtub Functional Component.
 */
export default Bathtub;
